import { useCallback } from 'react';
import type { FloatingButton } from 'shared/src/api/promotionsService/getPromotionComponents/types';
import { bridge } from 'shared/src/utils';

export const useClickFloatingButton = (
  button: FloatingButton,
  buttonIdx: number,
) => {
  return useCallback(() => {
    bridge.logAnalyticsEvent({
      name: 'CLICK_FLOATING_BUTTON',
      analytics: { ...button.logging.analytics, BUTTON_INDEX: buttonIdx },
      ably_only_log: { ...button.logging.ably_only_log },
    });
  }, [button.logging.ably_only_log, button.logging.analytics, buttonIdx]);
};
